/**
 * Thai (th-TH) - PLACEHOLDER
 * TODO Phase F+: 待泰國市場啟動時翻譯
 * 當前 fallback 到 en-US，避免缺譯報錯
 */
export default {
  layout: {
    brand: 'CardShop Kiosk',
    loading: 'Loading, please wait…',
    offline: 'Network connection lost',
  },
  error: {
    network: 'Network connection failed. Please check your network settings.',
    unknown: 'An unknown error occurred. Please contact staff.',
    maintenance: 'System maintenance in progress. Please wait.',
  },
  common: {
    btn: {
      confirm: 'Confirm',
      cancel: 'Cancel',
      retry: 'Retry',
      copy: 'คัดลอก',
    },
  },
  home: {
    welcome: 'Welcome to CardShop Kiosk',
    start: '開始購卡 / Start',
    startAria: 'Tap to start shopping',
    allCategories: 'All',
  },
  products: {
    title: '選擇商品 / Select Product',
    back: 'Back',
    lowStock: 'Low Stock',
    outOfStock: 'Sold Out',
    empty: 'No products available',
    loading: 'Loading products…',
    createOrderFailed: 'Failed to create order. Please try again.',
    activeOrderExists: 'You have an unfinished order. Please complete or wait for it to expire.',
    activeOrderExistsRedirecting: 'Active order detected, redirecting…',
  },
  order: {
    title: '訂單詳情 / Order Detail',
    back: 'Back',
    payNow: '前往付款 / Pay Now',
    cancel: '取消訂單 / Cancel',
    notFound: 'Order not found. Please try again.',
    cancelComingSoon: 'Order cancellation will be available in the next release.',
    status: {
      PENDING: 'Pending',
      IN_PAY: 'Paying',
      PAYING: 'Paying',
      PAID: 'Paid',
      DELIVERING: 'Delivering',
      COMPLETED: 'Completed',
      FAILED: 'Failed',
      CANCELLED: 'Cancelled',
      CANCELED: 'Cancelled',
      FULFILLED: 'Delivered',
      TIMEOUT: 'Timed Out',
      REFUNDING: 'Refunding',
      REFUNDED: 'Refunded',
    },
    paidAt: 'Payment Time',
    createdAt: 'Creation Time',
    unitPrice: 'Unit Price',
    paidAmount: 'Paid Amount',
    statusLabel: 'Status',
    cardNumber: 'Card Number',
    cardKey: 'Card Key',
    invoice: 'Invoice',
    invoiceNo: 'Invoice No.',
    invoiceIssued: 'Issued',
    invoiceApply: 'Request Invoice',
    invoiceApplyTitle: 'Request E-Invoice',
    invoiceCarrierType: 'Carrier Type',
    invoiceCarrierNone: 'None (Cloud Storage)',
    invoiceCarrierMobile: 'Mobile Barcode',
    invoiceCarrierCDC: 'Carrier Number',
    invoiceCarrierEZ: 'EasyCard / icash',
    invoiceCarrierEmail: 'Email',
    invoiceCarrierDonation: 'Donate Invoice',
    invoiceCarrierId: 'Carrier ID',
    invoiceCarrierIdPlaceholder: 'Enter carrier ID',
    invoiceEmail: 'Email',
    invoiceEmailPlaceholder: 'Enter email address',
    invoiceDonationHint: 'Invoice will be donated to Eden Social Welfare Foundation (Code: 25885)',
    invoiceSubmit: 'Submit',
    invoiceSubmitting: 'Submitting...',
    invoiceSuccess: 'Invoice requested! Invoice No.: {no}',
    invoiceSuccessDonation: 'Thank you for your donation! Invoice donated to Eden Social Welfare Foundation',
    invoiceFailed: 'Failed to request invoice, please retry',
    invoiceDuplicate: 'An invoice has already been issued for this order',
    invoiceAutoSubmit: 'Donate & Close ({seconds}s)',
    invoiceAutoSubmitDone: 'Invoice auto-donated',
    processSteps: 'Process Steps',
    redeemInfo: 'ข้อมูลการแลก',
    processing: 'Processing...',
    loadingPayload: 'Retrieving card info, please wait…',
    retryPayload: 'Retry fetching card info',
    payloadLoaded: 'Card info retrieved',
    payloadFailed: 'Failed to retrieve card info, please retry',
    statusLoading: 'Loading…',
    copySuccess: 'คัดลอกแล้ว',
    copyFailed: 'คัดลอกไม่สำเร็จ กรุณาคัดลอกด้วยตนเอง',
    sendCardEmail: 'ส่งรหัสการ์ดไปยังอีเมล',
    sendCardEmailTitle: 'ส่งรหัสการ์ดไปยังอีเมล',
    sendCardEmailHint: 'หมายเลขการ์ดและรหัสจะถูกส่งไปยังอีเมลที่คุณกรอก กรุณาตรวจสอบความถูกต้อง',
    sendCardEmailInput: 'กรอกที่อยู่อีเมล',
    sendCardEmailSubmit: 'ส่ง',
    sendCardEmailSending: 'กำลังส่ง...',
    sendCardEmailSuccess: 'ส่งรหัสการ์ดแล้ว กรุณาตรวจสอบอีเมล',
    sendCardEmailFailed: 'ส่งไม่สำเร็จ กรุณาลองใหม่',
    qrVerifyTitle: 'QR Code ตรวจสอบ',
    qrVerifyHint: 'ผู้ค้าสแกนเพื่อตรวจสอบว่าการ์ดนี้ถูกออกจากเครื่องแล้วหรือไม่',
    qrVerifyLoading: 'Generating QR code…',
    qrVerifyRetry: 'Retry QR code',
    customerContact: 'Customer Support',
    customerContactNone: 'Please contact staff if you need assistance',
    customerContactTitle: 'ติดต่อฝ่ายบริการลูกค้า',
    customerContactClose: 'ปิด',
  },
  ad: {
    exitTip: 'Touch screen to exit',
  },
  maintenance: {
    title: '設備維護中 / Under Maintenance',
    retry: 'Retry Connection',
    network_offline: 'Network connection lost. Please check your network.',
    auth_failed: 'Device authentication failed. Please contact support.',
    machine_locked: 'Device has been remotely locked.',
    dtu_offline: 'Card dispenser is offline. Waiting for recovery.',
    unknown: 'An unknown system error has occurred.',
    reconnecting: 'Attempting to reconnect…',
    wsStatus: 'WS Connection Status',
    networkOnline: 'Network Online',
    networkOffline: 'Network Offline',
    contactTitle: 'Contact Support',
    contactPhoneLabel: 'Hotline',
    contactPhone: '400-888-0000',
    contactWechat: '@cardshop_support',
    workOrder: 'Submit ticket: support.cardshop.com',
  },
  pay: {
    title: 'Payment',
    summary: 'Order Summary',
    orderPayment: 'ชำระคำสั่งซื้อ',
    method: 'Payment Method',
    cash: 'Cash',
    linepay: 'LinePay',
    card: 'Credit Card',
    applepay: 'Apple Pay',
    comingSoon: 'This payment method is coming soon',
    insertBill: 'Please insert banknotes',
    remaining: 'Remaining',
    completed: 'Payment Complete!',
    cancelled: 'Payment Cancelled',
    billReceived: '{amount} received',
    billInsertedFull: 'รับ {inserted} แล้ว',
    billInsertedStatus: 'รับ {inserted} แล้ว เหลือ {remaining}',
    contactSupport: 'Contact Support',
    cancelOrder: 'Cancel Order',
    timeout: 'No activity detected. Please complete payment soon.',
    orderNotFound: 'Order not found. Please place a new order.',
    fullyPaidRedirect: 'Payment complete. Redirecting…',
    // ── F.12 new: change / bill rejected / timeout ───────────────────────────
    change: {
      label: 'กรุณารับเงินทอน {amount}',
    },
    billRejected: 'เครื่องอ่านธนบัตรไม่ได้ชั่วคราว กรุณาลองใหม่ หากยังไม่ได้โปรดแจ้งพนักงาน',
    billTimeout: 'หมดเวลาใส่ธนบัตร คำสั่งซื้อถูกยกเลิก กรุณาเลือกสินค้าใหม่',
    countdown: 'กรุณาใส่ธนบัตรภายใน {time} มิฉะนั้นคำสั่งซื้อจะถูกยกเลิก',
    countdownExpired: 'คำสั่งซื้อหมดเวลา กรุณาเลือกสินค้าใหม่',
  },
  toast: {
    dismiss: 'Dismiss',
  },
  header: {
    online: 'Online',
    offline: 'Offline',
    reconnecting: 'Reconnecting',
  },
  footer: {
    online: 'Network OK',
    offline: 'Network Down',
    reconnecting: 'Network Reconnecting',
  },
}
